module.exports = __webpack_public_path__ + "media/lightningStrike_1.f2866f91.mp3";